import { getConsentPolicyManager } from './consent-policy-accessor';
import { ALLOW_ALL_POLICY } from './consts';
var ConsentPolicyAccessor = /** @class */ (function () {
    function ConsentPolicyAccessor(env) {
        if (env) {
            this.env = env;
        }
        this.consentPolicyAccess = getConsentPolicyManager(this.env);
    }
    ConsentPolicyAccessor.prototype.clearReference = function () {
        if (this.consentPolicyAccess && this.consentPolicyAccess.deleteReference) {
            this.consentPolicyAccess = undefined;
        }
    };
    ConsentPolicyAccessor.prototype.getCurrentConsentPolicy = function () {
        if (!this.consentPolicyAccess) {
            this.consentPolicyAccess = getConsentPolicyManager(this.env);
        }
        var policyObj = (this.consentPolicyAccess &&
            this.consentPolicyAccess.getCurrentConsentPolicy()) ||
            ALLOW_ALL_POLICY;
        this.clearReference();
        return policyObj.policy ? policyObj.policy : policyObj;
    };
    ConsentPolicyAccessor.prototype.getConsentPolicyHeader = function (valueOnly) {
        if (valueOnly === void 0) { valueOnly = false; }
        if (!this.consentPolicyAccess) {
            this.consentPolicyAccess = getConsentPolicyManager(this.env);
        }
        var consentPolicyHeaderObj = (this.consentPolicyAccess &&
            this.consentPolicyAccess._getConsentPolicyHeader()) || {
            'consent-policy': '',
        };
        this.clearReference();
        return valueOnly
            ? consentPolicyHeaderObj['consent-policy']
            : consentPolicyHeaderObj;
    };
    return ConsentPolicyAccessor;
}());
export { ConsentPolicyAccessor };
//# sourceMappingURL=index.js.map